import Constants from '../constants/action'

const initialState = {
  openCentre: false,
  messages: [],
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case Constants.NOTIFICATION_CENTRE_TOGGLE:
      return Object.assign({}, state, {
        openCentre: !state.openCentre,
      })

    default:
      return state
  }
}

export default reducer
